import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import { updateCurrentAccountPrimaryEmail } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const EmailUpdateForm = () => {
  const state = useAccountState();
  const { onResponse, onError, updateEmailFormEmail, updateEmailFormPassword, closeEmailUpdateModal } = useAccountActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateCurrentAccountPrimaryEmail({
      onResponse,
      onError,
      body: {
        primaryEmail: state?.emailUpdateForm?.email || '',
        password: state?.emailUpdateForm?.password || '',
        authenticityToken: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Email" id="email">
        <Input
          type="email"
          value={state?.emailUpdateForm?.email || ''}
          onChange={(e) => updateEmailFormEmail(e.target.value)}
        />
      </Field>

      <Field label="Password" id="password">
        <Input
          type="password"
          value={state?.emailUpdateForm?.password || ''}
          onChange={(e) => updateEmailFormPassword(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeEmailUpdateModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Update Email
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default EmailUpdateForm;
